import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UploadedFile, UploadedFileType } from '@prism/prism-shared';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'prism-image-carousel-dialog',
  templateUrl: './image-carousel-dialog.component.html',
  styleUrls: ['./image-carousel-dialog.component.scss']
})
export class ImageCarouselDialogComponent implements OnInit, OnDestroy {
  @Input() args!: { files: UploadedFile[] };

  imageFiles: UploadedFile[] = [];
  currentIndex: number = 0;
  currentImage$ = new BehaviorSubject<UploadedFile | null>(null);
  private unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    // Filter for image files only
    this.imageFiles = this.args.files.filter(file => file.type === UploadedFileType.Image && file.active);
    
    // Set initial image
    if (this.imageFiles.length > 0) {
      this.currentImage$.next(this.imageFiles[0]);
    }
  }

  navigate(direction: number): void {
    const newIndex = this.currentIndex + direction;
    if (newIndex >= 0 && newIndex < this.imageFiles.length) {
      this.currentIndex = newIndex;
      this.currentImage$.next(this.imageFiles[this.currentIndex]);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}